import { render, staticRenderFns } from "./ActiviteReservee.vue?vue&type=template&id=6803b8db&scoped=true"
import script from "./ActiviteReservee.vue?vue&type=script&lang=js"
export * from "./ActiviteReservee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6803b8db",
  null
  
)

export default component.exports